jQuery($ => {

  const selectTarget = (fromElement, selector) => {
    if (!(fromElement instanceof HTMLElement)) {
      return null;
    }
  
    return fromElement.querySelector(selector);
  };
  
  const resizeData = {
    tracking: false,
    startWidth: null,
    startCursorScreenX: null,
    handleWidth: 10,
    resizeTarget: null,
    parentElement: null,
    maxWidth: null,
  };
  
  $('.us-page').on('mousedown', '.resize-handle--x', null, (event) => {
    if (event.button !== 0) {
      return;
    }
  
    event.preventDefault();
    event.stopPropagation();
  
    const handleElement = event.currentTarget;
    
    if (!handleElement.parentElement) {
      console.error(new Error("Parent element not found."));
      return;
    }
    
    // Use the target selector on the handle to get the resize target.
    const targetSelector = handleElement.getAttribute('data-target');
    const targetElement = selectTarget(handleElement.parentElement, targetSelector);
  
    if (!targetElement) {
      console.error(new Error("Resize target element not found."));
      return;
    }
    
    resizeData.startWidth = $(targetElement).outerWidth();
    resizeData.startCursorScreenX = event.screenX;
    resizeData.resizeTarget = targetElement;
    resizeData.parentElement = handleElement.parentElement;
    resizeData.maxWidth = $(handleElement.parentElement).innerWidth() - resizeData.handleWidth;
    $('.us-page').addClass('us-page--resizing');
    resizeData.tracking = true;
  });
  
  $('.us-page').on('mousemove', null, null, _.debounce((event) => {
    if (resizeData.tracking) {
      const cursorScreenXDelta = event.screenX - resizeData.startCursorScreenX;
      const newWidth = Math.min(resizeData.startWidth + cursorScreenXDelta, resizeData.maxWidth);
      
      $(resizeData.resizeTarget).outerWidth(newWidth);
      $('.us-page').trigger('resizing');
    }
  }, 1));
  
  $('.us-page').on('mouseup', null, null, (event) => {
    $('.us-page').removeClass('us-page--resizing');
    
    if (resizeData.tracking) {
      resizeData.tracking = false;
    }
  });

  $('.us-page').on('resizing', () => {
    let width  = $('.us-main').width(),
        height = $('.us-main').height();

    // $('.us-main__size').text(`${width}px x ${height}px`);
    $('.us-m-toolbar__breakpoints .us-a-select__value').text(`${width}px x ${height}px`);
  });

  $(window).on('resize', () => {
    let width  = $('.us-main').width(),
        height = $('.us-main').height();

    // $('.us-main__size').text(`${width}px x ${height}px`);
    $('.us-m-toolbar__breakpoints .us-a-select__value').text(`${width}px x ${height}px`);
  });

});